import { promoImpression, promoClick } from "../../TrackingInformation";
import { setGa4ItemListReferrel } from "../../TrackingInformation/ga4ItemListReferral";
const SUPPLIER_AD_LIST_ID = 'supplier_ad';
export function isSupplierAdContentCard(content) {
    const contentType = ((content === null || content === void 0 ? void 0 : content.type) || '').toLowerCase();
    return contentType === 'supplier_ad' || contentType === 'supplierad' || contentType === 'supplieradpage';
}
export function getSupplierAdItemListId(content) {
    return isSupplierAdContentCard(content) ? SUPPLIER_AD_LIST_ID : undefined;
}
export function onView(visible, content, index) {
    if (!visible || !!!content)
        return;
    promoImpression(content.trackingInformationPromo, index);
}
export function onClick(event, content, index) {
    if (!!!content)
        return;
    const itemListId = getSupplierAdItemListId(content);
    if (itemListId) {
        setGa4ItemListReferrel(itemListId);
    }
    promoClick(content.trackingInformationPromo, index);
}
